import { HEIGHT_TRANSITION } from '../../animation.constants';
export function getContentValueKey(transition) {
  if (transition === HEIGHT_TRANSITION) {
    return 'offsetHeight';
  }
  return '';
}